import type { AvailableLocales, MessageSchema } from '@/locales/schema'
import { createI18n } from 'vue-i18n'
import enUS from './locales/en/index'
import ruRU from './locales/ru/index'

export const i18n = createI18n<[MessageSchema], AvailableLocales>({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': enUS,
    'ru-RU': ruRU,
  },
})
